import { apiURl } from "../configuration/apiconfig";
import { fetchAndReturn } from "../utils/utility";

// -----QRUSERS-----
const getQRUsersRequest = (token) => {
  const organizationId = localStorage.getItem("organizationId");
  const url = apiURl + "users/qrall?organizationId=" + organizationId;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const deleteQRUsersRequest = (token, id) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "users/qr/delete?organizationId=" +
    organizationId +
    "&UserToDeleteId=" +
    id;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const saveQRUsersRequest = (token, { user }) => {
  const organizationId = localStorage.getItem("organizationId");
  const url =
    apiURl +
    "users/qr/edit?organizationId=" +
    organizationId +
    "&firstName=" +
    user.firstName +
    "&lastName=" +
    user.lastName +
    "&id=" +
    user.id;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const createQRUserRequest = (token, { user }) => {
  user["organizationId"] = localStorage.getItem("organizationId");
  const url = apiURl + "users/qr/register";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(user),
  };

  return fetchAndReturn(url, parameters);
};

// -----QRManagement-----

const getQRTablesRequest = (token) => {
  const url =
    apiURl +
    "mymenu/tables?organizationId=" +
    localStorage.getItem("organizationId");
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const scanQRTableRequest = (token, { guid }) => {
  // const organizationId = localStorage.getItem('organizationId');
  const url = apiURl + "mymenu/tables/ordering/" + guid;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const saveQRTablesRequest = (token, { table }) => {
  const url = apiURl + "mymenu/tables/" + table.identifier;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(table),
  };

  return fetchAndReturn(url, parameters);
};

const createQRTablesRequest = (token, { table }) => {
  table["organizationId"] = parseInt(localStorage.getItem("organizationId"));

  const url = apiURl + "mymenu/tables";
  const parameters = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
    body: JSON.stringify(table),
  };

  return fetchAndReturn(url, parameters);
};

const deleteQRTablesRequest = (token, table) => {
  const url = apiURl + "mymenu/tables/" + table.identifier;
  const parameters = {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const generateQRTXTRequest = (token, count) => {
  const url = apiURl + "tables/generateQRTablesTXT?count=" + count;
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetch(url, parameters)
    .then((response) => {
      const statusCode = response.status;
      const data = response;
      return Promise.all([statusCode, data]);
    })
    .then(([res, data]) => {
      return [res, data];
    })
    .catch((error) => {
      return error;
    });
};

const getTouchSaleTablesRequest = (token) => {
  const url =
    apiURl +
    "tables?restaurantId=" +
    localStorage.getItem("restaurantId") +
    "&organizationId=" +
    localStorage.getItem("organizationId");
  const parameters = {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};

const dispatchSetTableStatusRequest = (tableId, status, token) => {
  const url = apiURl + "tables/" + tableId + "/setStatus?active=" + status;
  const parameters = {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };

  return fetchAndReturn(url, parameters);
};
export {
  getQRUsersRequest,
  deleteQRUsersRequest,
  saveQRUsersRequest,
  createQRUserRequest,
  getQRTablesRequest,
  scanQRTableRequest,
  saveQRTablesRequest,
  createQRTablesRequest,
  deleteQRTablesRequest,
  getTouchSaleTablesRequest,
  dispatchSetTableStatusRequest,
  generateQRTXTRequest,
};
